// extracted by mini-css-extract-plugin
export default {"footer":"CreateTicketTypeModal_footer__9dA12","footerBtn":"CreateTicketTypeModal_footerBtn__StflC"};